const DeleteDialogConfigurations = {
    width: '48%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" }
};
const NoteDialogConfigurations = {
    width: '40%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" },
    data: {}
};

/*
 * Public API Surface of dialog-configuration-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DeleteDialogConfigurations, NoteDialogConfigurations };
//# sourceMappingURL=dialog-configuration-library.js.map
